import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { CheckboxModule, FormFieldModule, SectionComponent } from "@bitwarden/components";
import { SendTextDetailsComponent } from "@bitwarden/send-ui";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  selector: "app-bv-send-text-details",
  templateUrl: "./bv-send-text-details.component.html",
  imports: [CheckboxModule, I18nPipe, ReactiveFormsModule, FormFieldModule, SectionComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BvSendTextDetailsComponent extends SendTextDetailsComponent {}
